import React from 'react';

import DayExpanded from '@redturtle/iovisit-theme/components/Views/Itinerary/DayExpanded';

const ItineraryDayView = ({ content, location }) => {
  return (
    <div id="page-itinerary" className="ui container">
      <div className="day">
        <DayExpanded day={content} showLeadImage={false} />
      </div>
    </div>
  );
};

export default ItineraryDayView;
